// extracted by mini-css-extract-plugin
export const page = "page-module--page--1HEEb";
export const page__inner = "page-module--page__inner--21Q_e";
export const page__title = "page-module--page__title--2GAe_";
export const page__body = "page-module--page__body--3IWnH";